import React, { useState } from 'react';
import { collection, addDoc, doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../contexts/AuthContext';
import './CalendarModal.css';

// Generate random 6-character invite code
function generateInviteCode() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Removed confusing chars like 0, O, 1, I
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

export default function CreateCalendarModal({ onClose, onSuccess }) {
  const { currentUser } = useAuth();
  const [calendarName, setCalendarName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();

    if (!calendarName.trim()) {
      return setError('يرجى إدخال اسم المجموعة');
    }

    try {
      setLoading(true);
      setError('');

      const inviteCode = generateInviteCode();

      // Create calendar document
      const calendarRef = await addDoc(collection(db, 'calendars'), {
        name: calendarName.trim(),
        createdBy: currentUser.uid,
        inviteCode: inviteCode,
        members: [currentUser.uid],
        admins: [currentUser.uid],
        createdAt: new Date().toISOString()
      });

      // Update user's calendars array
      await updateDoc(doc(db, 'users', currentUser.uid), {
        calendars: arrayUnion(calendarRef.id)
      });

      // Success!
      onSuccess({
        id: calendarRef.id,
        name: calendarName,
        inviteCode: inviteCode
      });

    } catch (err) {
      console.error('Error creating calendar:', err);
      setError('حدث خطأ أثناء إنشاء المجموعة. يرجى المحاولة مرة أخرى.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content calendar-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>إنشاء مجموعة جديدة</h2>
          <button className="close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <p className="modal-description">
          أنشئ تقويماً خاصاً لعائلتك أو فريقك. ستحصل على رمز دعوة لمشاركته مع الآخرين.
        </p>

        {error && <div className="error-alert">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="calendarName">اسم المجموعة *</label>
            <input
              id="calendarName"
              type="text"
              value={calendarName}
              onChange={(e) => setCalendarName(e.target.value)}
              placeholder="مثال: استراحة العائلة، شقة الأصدقاء"
              disabled={loading}
              maxLength={50}
            />
            <span className="input-hint">{calendarName.length}/50</span>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || !calendarName.trim()}
            >
              {loading ? 'جاري الإنشاء...' : 'إنشاء المجموعة'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}